const mainColors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange']
//const mainSubs = ['lighten', 'darken', 'accent']
// const colors = []
// for (let c of mainColors) {
//   colors.push(c)
//   for (let s of mainSubs) {
//     let i = 4
//     while (i-- > 0) {
//       colors.push(`${c} ${s}-${i+1}`)
//     }
//   }
// }
// export default colors
export default mainColors